import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React, { useMemo } from 'react'
import { Badge } from 'reactstrap'
import useTranslation from '../../../../../i18n/useTranslation'
import FilterBadge from '../../../../../common/FilterBadge'

const StatusesFilter = (props) => {
    const { translate } = useTranslation()
    const { statuses, statusFilters, setStatusFilters, useInner = false } = props
    const selectorData = useMemo(() => statuses.map((item) => ({
        name: item?.label || item,
        id: item?.id || item,
        Component: (
            <Badge
                color={item?.statusColor?.startsWith('#') ? undefined : (item?.statusColor || 'secondary')}
                style={{
                    width: 8,
                    height: 8,
                    minHeight: 8,
                    padding: 0,
                    marginRight: 8,
                    lineHeight: 0,
                    flexShrink: 0,
                    ...(item?.statusColor?.startsWith('#') ? {
                        backgroundColor: item.id === 'pending' ? 'transparent' : item.statusColor,
                        border: item.id === 'pending' ? `2px solid ${item.statusColor}` : 'none'
                    } : { border: 'none' })
                }}
                pill
                className='point'
            >
                &nbsp;
            </Badge>
        ),
        // eslint-disable-next-line
    })), [statuses, translate])

    const checkBoxSelectorProps = {
        setDataFilters: setStatusFilters,
        direction: 'bottom',
        dataFilters: statusFilters,
        typeFilter: 'statuses',
        data: selectorData,
        strings: {
            viewAll: translate('filters.plans.viewAll'),
            buttonCancel: translate('filters.plans.buttonCancel'),
            buttonApply: translate('filters.plans.buttonApply'),
            search: translate('filters.plans.search')
        }
    }
    return (
        useInner ? 
        <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkBoxSelectorProps}/> :
        <CheckboxSelector {...checkBoxSelectorProps}>
            <FilterBadge
                title={translate('filters.plans.status.title')}
                options={selectorData}
                selectedIds={statusFilters}
                showOptionComponents
                onClearFilters={() => setStatusFilters([])}
            />
        </CheckboxSelector>
    )
}
export default StatusesFilter
